import api from './api/api';

class AuditService {
  getAuditLogs(params = {}) {
    const {
      page = 1,
      per_page = 50,
      operation = 'all',
      success = 'all',
      user_id = null
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      operation,
      success
    });

    if (user_id) {
      queryParams.append('user_id', user_id.toString());
    }

    return api.get(`/admin/audit/logs/?${queryParams}`);
  }

  getOperationTypes() {
    return api.get('/admin/audit/operations/');
  }
}

export default new AuditService();
